const state = {
  results: null,
  isProcessing: false,
  error: null,
  currentMessageId: null,
  imageUrl: null,
};

const mutations = {
  setResults(state, results) {
    state.results = results;
    state.isProcessing = false;
    state.error = null;
    state.currentMessageId = results.message_id;
    state.imageUrl = results.file_url || null;
  },
  clearResults(state) {
    state.results = null;
    state.isProcessing = false;
    state.error = null;
    state.currentMessageId = null;
    state.imageUrl = null;
  },
  setProcessing(state, { isProcessing, message_id }) {
    state.isProcessing = isProcessing;
    state.currentMessageId = message_id;
    if (isProcessing) {
      state.results = null;
      state.error = null;
      state.imageUrl = null;
    }
  },
  setError(state, { error, message_id }) {
    state.error = error;
    state.isProcessing = false;
    state.currentMessageId = message_id;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};